import { BasicTrigger } from "lord-icon-element";
import React from "react";
import { Redirect } from "react-router-dom";
import BasicTwosVerify from "../pages/Authentication/BasicTwosVerify";

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import DashboardMainPage from "../pages/Dashboard";


const authProtectedRoutes = [
  { path: "/dashboard/:id", component: DashboardMainPage },
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/enter-otp", component: BasicTwosVerify },

];

export { authProtectedRoutes, publicRoutes };
